import { defineMessages } from 'react-intl';

const messages = defineMessages({
  merchandise: {
    description: 'customsContent.merchandise',
    defaultMessage: 'Merchandise',
    id: 's7V7Kc',
  },
  documents: {
    description: 'customsContent.documents',
    defaultMessage: 'Documents',
    id: '3sqF+1',
  },
  gift: {
    description: 'customsContent.gift',
    defaultMessage: 'Gift',
    id: 'oYGRcO',
  },
  returnedGoods: {
    description: 'customsContent.returnedGoods',
    defaultMessage: 'Return, Repair, or Warranty',
    id: '7h1C7S',
  },
  sample: {
    description: 'customsContent.sample',
    defaultMessage: 'Sample',
    id: 'ao74EL',
  },
  other: {
    description: 'customsContent.other',
    defaultMessage: 'Other',
    id: 'tUgPlB',
  },
  eCommerceGoods: {
    description: 'customsContent.eCommerceGoods',
    defaultMessage: 'E-commerce goods',
    id: 'JNwAYw',
  },
  commercialSaleOfGoodsB2B: {
    description: 'customsContent.commercialSaleOfGoodsB2B',
    defaultMessage: 'Commercial sale of goods (B2B)',
    id: 'tWwEWv',
  },
});

export const CustomsContent = {
  Merchandise: {
    name: 'Merchandise',
    translation: messages.merchandise,
  },
  Documents: {
    name: 'Documents',
    translation: messages.documents,
  },
  Gift: {
    name: 'Gift',
    translation: messages.gift,
  },
  ReturnedGoods: {
    name: 'ReturnedGoods',
    translation: messages.returnedGoods,
  },
  Sample: {
    name: 'Sample',
    translation: messages.sample,
  },
  Other: {
    name: 'Other',
    translation: messages.other,
  },
  ECommerceGoods: {
    name: 'ECommerceGoods',
    translation: messages.eCommerceGoods,
  },
  CommercialSaleOfGoodsB2B: {
    name: 'CommercialSaleOfGoodsB2B',
    translation: messages.commercialSaleOfGoodsB2B,
  },
};

export const CustomsContentValues = Object.values(CustomsContent);
